export default "__VITE_ASSET__ByM_dBzx__"